import React, { useEffect, useState } from "react";
import { Row, Col, Button, Input, Label } from "reactstrap";
import swal from "sweetalert";
import { useSearchParams, useNavigate } from "react-router-dom";
import {
  CreateWarehousesave,
  _Get,
  _Put,
} from "../../ApiEndPoint/ApiCalling";

import {
  Update_Wareahouse_Byid,
  View_Wareahouse_Byid,
} from "../../ApiEndPoint/Api";
import axiosConfig from "../../AxiosConfig"
export default function WarehouseForm({ mode }) {

  const [searchParams] = useSearchParams();
const navigate = useNavigate();
  const warehouseId = searchParams.get("id");

  const currentMode = mode;
  const [formData, setFormData] = useState({
    Username: "",
    Password: "",
    warehouseName: "",
    warehouseMobile: "",
    address: "",
    landlineNumber: "",
    warehouseType: "Trading",
    status: "Active",

  });

  const isView = currentMode === "view";
  // 🔥 Load Data
  useEffect(() => {

    if (currentMode === "edit" || currentMode === "view") {

      axiosConfig
        .get(`/warehouse/view-warehouse-by-id/${warehouseId}`)

        .then((res) => {
          console.log("WAREHOUSE RES", res.data);

          const d = res?.data?.Warehouse;

          setFormData({
            Username: d?.Username || "",
            Password: d?.Password || "",
            warehouseName: d?.warehouseName || "",
            warehouseMobile: d?.mobileNo || "",
            address: d?.address || "",
            landlineNumber: d?.landlineNumber || "",
            warehouseType: d?.warehouseType || "Trading",
            status: d?.status || "Active",
          });

        })

        .catch((err) => {

          console.log(err);

          swal("Error loading");

        });

    }

  }, [warehouseId, currentMode]);

  // 🔥 Submit
 const submitHandler = async (e) => {
  e.preventDefault();

  const user = JSON.parse(
    localStorage.getItem("userData")
  );

  const payload = {
    Username: formData.Username,
    Password: formData.Password,
    warehouseName: formData.warehouseName,
    mobileNo: formData.warehouseMobile,
    address: formData.address,
    landlineNumber: formData.landlineNumber,
    status: formData.status,
    warehouseType: formData.warehouseType,
    database: user?.database,
    id: formData.warehouseName?.replace(/\s/g, ""),
  };

  try {
    if (currentMode === "create") {
      await CreateWarehousesave(payload);

      await swal({
        title: "Success",
        text: "Warehouse Created Successfully",
        icon: "success",
        button: "OK",
      });

      navigate("/production?view=warehouse");
    }

    if (currentMode === "edit") {
      await _Put(
        Update_Wareahouse_Byid,
        warehouseId,
        payload
      );

      await swal({
        title: "Success",
        text: "Warehouse Updated Successfully",
        icon: "success",
        button: "OK",
      });

      navigate("/production?view=warehouse");
    }
  } catch (error) {
    console.log("Warehouse Submit Error =>", error);

    await swal({
      title: "Error",
      text:
        error?.response?.data?.message ||
        "Something went wrong",
      icon: "error",
      button: "OK",
    });
  }
};

  return (
    <div className="erp-card">

      {/* 🔥 Header */}
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }}>
        <h2>
          {currentMode === "create"
            ? "Create Warehouse"
            : currentMode === "edit"
              ? "Edit Warehouse"
              : "View Warehouse"}
        </h2>

        <Button
          size="sm"
          onClick={() => window.history.back()}
          style={{
            padding: "4px 10px",
            fontSize: "12px",
            background: "#f1f5f9",
            border: "1px solid #cbd5e1",
            color: "#334155",
          }}
        >
          ← Back
        </Button>
      </div>

      <form onSubmit={submitHandler}>

        {/* Row 1 */}
        <Row>
          <Col md="3">
            <Label>UserName</Label>
            <Input
              value={formData.Username}
              disabled={isView}
              onChange={(e) =>
                setFormData({ ...formData, Username: e.target.value })
              }
            />
          </Col>

          <Col md="3">
            <Label>Password</Label>
            <Input
              type="password"
              value={formData.Password}
              disabled={isView}
              onChange={(e) =>
                setFormData({ ...formData, Password: e.target.value })
              }
            />
          </Col>
          <Col md="3">
            <Label> Warehouse Type </Label>
            <Input type="select" value={formData.warehouseType}
              disabled={isView}
              onChange={(e) => setFormData({
                ...formData,
                warehouseType: e.target.value,
              })} >
              <option value=""> Select Warehouse Type </option>
              <option value="Trading"> Trading </option>
              <option value="Production"> Production </option>
            </Input>
          </Col>
          <Col md="3">
            <Label>Warehouse Name</Label>
            <Input
              value={formData.warehouseName}
              disabled={isView}
              onChange={(e) =>
                setFormData({ ...formData, warehouseName: e.target.value })
              }
            />
          </Col>
        </Row>

        {/* Row 2 */}
        <Row className="mt-2">
          <Col md="4">
            <Label>Mobile</Label>
            <Input
              type="number"
              value={formData.warehouseMobile}
              disabled={isView}
              onChange={(e) =>
                setFormData({ ...formData, warehouseMobile: e.target.value })
              }
            />
          </Col>

          <Col md="4">
            <Label>Landline</Label>
            <Input
              type="number"
              value={formData.landlineNumber}
              disabled={isView}
              onChange={(e) =>
                setFormData({ ...formData, landlineNumber: e.target.value })
              }
            />
          </Col>

          <Col md="4">
            <Label>Status</Label>
            <Input
              type="select"
              value={formData.status}
              disabled={isView}
              onChange={(e) =>
                setFormData({ ...formData, status: e.target.value })
              }
            >
              <option value="Active">Active</option>
              <option value="Deactive">Deactive</option>
            </Input>
          </Col>
        </Row>

        {/* Row 3 */}
        <Row className="mt-2">
          <Col md="12">
            <Label>Address</Label>
            <Input
              value={formData.address}
              disabled={isView}
              onChange={(e) =>
                setFormData({ ...formData, address: e.target.value })
              }
            />
          </Col>
        </Row>

        {/* Button */}
        {!isView && (
          <div className="mt-3">
            <Button color="primary" type="submit">
              {currentMode === "edit" ? "Update" : "Create"}
            </Button>
          </div>
        )}
      </form>
    </div>
  );
}